import { baseQueryWithReauth } from './baseQueryWithReauth';
import { graphqlBaseQuery } from './graphqlBaseQuery';

// One baseQuery for both transports: `{ document, variables }` → GraphQL, `{ url }` → REST.
export const baseQuery = async (args, api, extraOptions) => {
  if (args?.document) {
    return graphqlBaseQuery(args, api, extraOptions);
  }
  return baseQueryWithReauth(args, api, extraOptions);
};
